import { render, staticRenderFns } from "./Collage.vue?vue&type=template&id=ffcf46e2&scoped=true&"
import script from "./Collage.vue?vue&type=script&lang=js&"
export * from "./Collage.vue?vue&type=script&lang=js&"
import style0 from "./Collage.vue?vue&type=style&index=0&id=ffcf46e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcf46e2",
  null
  
)

export default component.exports